import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getLocationFull } from '../Api'

export default generateApiAction({
  baseType: Types.LOCATIONS.GET.FULL,
  api: getLocationFull,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/locations/GetFullAction.js